export default "__VITE_ASSET__CFc5ZGjL__"